import { Tag } from 'src/components/atoms';
import { FormState } from 'src/types';
import styled from 'styled-components';

export const StyledTag = styled(Tag)<{ state?: FormState }>`
  ${(props) => {
    if (!props.state) return '';
    switch (props.state) {
      case FormState.WARNING:
        return `
          border: 1px solid;
            background-color: ${props.theme.atlas.semantic.color.status.warning.background};
            border-color: ${props.theme.atlas.semantic.color.status.warning.default};
        `;
      case FormState.ERROR:
        return `
          border: 1px solid;
            background-color: ${props.theme.atlas.semantic.color.status.error.background};
            border-color: ${props.theme.atlas.semantic.color.status.error.default};
        `;
      case FormState.SUCCESS:
        return `
          border: 1px solid;
            background-color: ${props.theme.atlas.semantic.color.status.success.background};
            border-color: ${props.theme.atlas.semantic.color.status.success.default};
        `;
      default:
        return '';
    }
  }}
`;
